require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/fn/array/from.js
// module id = 324
// module chunks = 0